import {RootStore} from "store/useRootStore"
import {RealDeviceStore} from "store/admin/real-device.store"
import {PathTrackingStore} from "store/admin/path-tracking.store"

export class AdminStore {
    rootStore: RootStore
    realDeviceStore: RealDeviceStore
    pathTrackingStore: PathTrackingStore
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        this.realDeviceStore = new RealDeviceStore(this)
        this.pathTrackingStore = new PathTrackingStore(this)
    }
}